import { useBrand } from './brand-context';
import { BRAND_CAPABILITIES } from './registry';
import type { BrandCapabilities } from './registry';

const useBrandCapabilities = (): BrandCapabilities => BRAND_CAPABILITIES[useBrand().brand];

export { useBrandCapabilities };
